import React, { useEffect, useRef } from 'react';
import Icon from '@common/assets';
import Colors from '@domain/constant/colors';
import classnames from 'classnames/bind';
import styles from './index.module.scss';

const cx = classnames.bind(styles);

interface SearchInputProps {
  setValue: (value: string) => void;
}

const SearchInput = ({ setValue }: SearchInputProps) => {
  const ref = useRef<HTMLInputElement | null>(null);
  const [inputValue, setInputValue] = React.useState('');

  const handleClear = () => {
    setInputValue('');
    setValue('');
  };

  const handleOnChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setInputValue(e.target.value);
  };

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setValue(inputValue);
    }, 200);
    return () => clearTimeout(timeoutId);
  }, [inputValue]);

  useEffect(() => {
    ref.current?.focus();
  }, []);

  return (
    <div className={cx('inputArea')}>
      <div className={cx('inputWrap')}>
        <input
          ref={ref}
          type={'text'}
          placeholder={'기업명 검색'}
          className={cx('input')}
          value={inputValue}
          onChange={handleOnChange}
          maxLength={40}
        />
        <div className={cx('searchIcon')}>
          <Icon name="searchLight" width={24} height={24} fill={Colors.C_COOL_GRAY_70} />
        </div>
        {inputValue.length > 0 && (
          <button className={cx('clearBtn')} onClick={handleClear}>
            <Icon name="closeLight" width={24} height={24} fill={Colors.C_COOL_GRAY_70} />
          </button>
        )}
      </div>
    </div>
  );
};

export default SearchInput;
